import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("globo:lang") || "fr");
  useEffect(() => {
    localStorage.setItem("globo:lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key) => translations[lang]?.[key] ?? translations.fr[key] ?? key, [lang]);
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
